import React from 'react';
import {
  Box,
  Typography,
  Chip,
  Stack,
  Paper,
  Tooltip,
} from '@mui/material';

interface Variable {
  key: string;
  label: string;
  description: string;
  example: string;
}

export const AVAILABLE_VARIABLES: Variable[] = [
  { key: 'firstName', label: 'First Name', description: "Lead's first name", example: 'John' },
  { key: 'lastName', label: 'Last Name', description: "Lead's last name", example: 'Doe' },
  { key: 'fullName', label: 'Full Name', description: "Lead's full name", example: 'John Doe' },
  { key: 'companyName', label: 'Company Name', description: "Lead's company name", example: 'TechCorp Inc.' },
  { key: 'email', label: 'Email', description: "Lead's email address", example: 'john@techcorp.com' },
  { key: 'phone', label: 'Phone', description: "Lead's phone number", example: '+1234567890' },
  { key: 'jobTitle', label: 'Job Title', description: "Lead's job title", example: 'CEO' },
  { key: 'industry', label: 'Industry', description: "Lead's industry", example: 'Technology' },
  { key: 'location', label: 'Location', description: "Lead's location", example: 'New York, USA' },
];

interface VariablePillsProps {
  onInsert: (variableKey: string) => void;
  usedVariables?: string[];
}

const VariablePills: React.FC<VariablePillsProps> = ({ onInsert, usedVariables = [] }) => {
  return (
    <Paper sx={{ p: 2, backgroundColor: 'grey.50', border: '1px solid', borderColor: 'divider' }}>
      <Typography variant="subtitle2" gutterBottom sx={{ mb: 1.5, fontWeight: 600, color: 'text.primary' }}>
        📝 Available Variables - Click to Insert:
      </Typography>
      <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
        {AVAILABLE_VARIABLES.map((variable) => {
          const isUsed = usedVariables.includes(variable.key);
          return (
            <Tooltip
              key={variable.key}
              title={
                <Box>
                  <Typography variant="body2" sx={{ fontWeight: 600, mb: 0.5 }}>
                    {variable.label}
                  </Typography>
                  <Typography variant="caption" display="block">
                    {variable.description}
                  </Typography>
                  <Typography variant="caption" display="block" sx={{ mt: 0.5, fontStyle: 'italic' }}>
                    Example: {variable.example}
                  </Typography>
                </Box>
              }
              arrow
              placement="top"
            >
              <Chip
                label={variable.label}
                onClick={() => onInsert(variable.key)}
                color={isUsed ? 'primary' : 'default'}
                variant={isUsed ? 'filled' : 'outlined'}
                sx={{
                  cursor: 'pointer',
                  fontWeight: isUsed ? 600 : 400,
                  '&:hover': {
                    backgroundColor: isUsed ? 'primary.dark' : 'primary.light',
                    color: 'primary.contrastText',
                    transform: 'scale(1.05)',
                  },
                  transition: 'all 0.2s',
                }}
              />
            </Tooltip>
          );
        })}
      </Stack>
    </Paper>
  );
};

export default VariablePills;

